import PhoneInput from "components/atoms/input/phone/PhoneInput";
import * as s from "../../LoginStyled";
import * as cs from "../../../SignCommonStyled";
import { UnderlineText, ValidateWord } from "components/atoms/text/Text";
import { KeyboardEvent } from "react";
import { Validate, ValidateMsg } from "api/interfaces/commonInterface.interface";
import { LOGIN_STEP } from "../../LoginContainer";
import { COLORS } from "styles/colors";
import BigButton from "components/atoms/buttons/BigButton";

interface Props {
  onChangePhoneNumber: (number: string) => void;
  onClickSentEmail: () => void;
  isValidated: Validate;
  validateMsg: ValidateMsg;
  onChangeStep: (step: LOGIN_STEP) => void;
}

export default function ForgotEmail({
  onChangePhoneNumber,
  onClickSentEmail,
  isValidated,
  validateMsg,
  onChangeStep,
}: Props) {
  return (
    <>
      <s.InputWrapper>
        <s.LoginInfo>
          <h3>FORGOT EMAIL</h3>
          <p className="description">
            Enter the phone number saved in your profile to receive the
            associated email address.
          </p>
        </s.LoginInfo>
        <PhoneInput
          login
          placeholder="Please enter a phone number"
          onChange={onChangePhoneNumber}
          onEnterKeyPress={(e: KeyboardEvent<HTMLInputElement>) => {
            if (e.key === "Enter") {
              onClickSentEmail();
            }
          }}
          isValidated={isValidated.tel}
          data-testid="auth-forget-phone-input-change-phone-number"
        />

        {validateMsg.tel && (
          <cs.ValidateWrapper>
            <ValidateWord data-testid="auth-forget-validate-tel">{validateMsg.tel}</ValidateWord>
          </cs.ValidateWrapper>
        )}

        <BigButton
          label="Send"
          onClickBtn={onClickSentEmail}
          data-testid="auth-forget-button-click-sent-email"
        />

        <s.Bottom center>
          <UnderlineText
            id="dw_login_button_forward_email"
            fontSize={14}
            color={COLORS.BUTTONS1}
            onClick={() => onChangeStep(LOGIN_STEP.INPUT_EMAIL)}
            data-testid="auth-forget-forward-email-change-step"
          >
            Go Back
          </UnderlineText>
        </s.Bottom>
      </s.InputWrapper>
    </>
  );
}
